import React from 'react'
import './videoProgress.css'
import { getFirstFile } from '../utilities'

export default ({video, className, onCancel}) => {
  let percent = 0;
  let status = '';
  let key = 'upload'
  if (video.waitingToUpload) {
    status = 'Upload queued.'
  } else if (video.queued) {
    key = 'processing'
    status = 'Queued for processing.'
  } else if (video.source_url && video.status == 0) {
    key = 'downloading'
    status = 'Downloading...'
  } else if (video.status == 0) {
    percent = video.upload_percent || 0;
    if (video.retries) {
      status = 'Still working...'
    } else if (isNaN(video.upload_speed)) {
      status = 'Uploading...';
    } else {
      status = 'Uploading... ' + ((video.upload_speed / 1048576) * 8).toFixed(1).toString() + ' Mbps'
    }
  } else {
    key = 'processing'
    status = 'Processing...'
    percent = video.percent || 0;
  }
  return (
    <div className={(className || "") + " progress-overlay"}>
      <div className="progress-status">{status}</div>
      <div className="progress-bar-track">
        <div className="progress-bar-value" key={key} style={{width: percent.toString() + "%"}}>
        </div>
      </div>
      {onCancel ? 
        <div className="progress-cancel">
          <a href="#" onClick={e => {
            e.preventDefault(); 
            onCancel();
          }}>Cancel</a>
        </div>
      : ''}
    </div>
  )
}
